export default __webpack_public_path__ + "static/media/raywood.97968e3b.svg";